
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-hub/[...slug]",
      function () {
        return require("private-next-pages/content-hub/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-hub/[...slug]"])
      });
    }
  